import React from 'react';
import { ChatContext } from 'contexts';
import Chat from './Chat';

export default ({ ownerable, ownerableType, ownerableId, close }) => (
  <ChatContext.Provider value={{ ownerable, ownerableType, ownerableId }}>
    <Chat close={close} />
  </ChatContext.Provider>
);
